export const hasSSISupport = () => false;

export const rememberSSIDeclined = () => {};

export const shouldSkipSSI = () => true;
